import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CharterDAO } from '../../../../core/services/dao/charterDAO';
import { AppMessagingService } from '../../../../core/services/app-messaging.service';

@Component({
  selector: 'app-customer-boat-request-dialog',
  templateUrl: './customer-boat-request-dialog.component.html',
  styleUrls: ['./customer-boat-request-dialog.component.scss'],
})
export class CustomerBoatRequestDialogComponent implements OnInit {
  messageBody: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CustomerBoatRequestDialogComponent>,
    private charterDAO: CharterDAO,
    private appMessagingService: AppMessagingService,
  ) {}

  ngOnInit() {}

  sendDeliveryRequest() {
    this.charterDAO
      .customerRequestBoatDelivery(this.data.charterId, this.messageBody)
      .subscribe((res) => {
        if (res) {
          this.appMessagingService.openSnack(
            'Success! Someone from our team will be in touch with you soon. ',
          );
          this.dialogRef.close();
        }
      });
  }
}
